
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/visual-designer",
      function () {
        return require("private-next-pages/visual-designer.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/visual-designer"])
      });
    }
  